import { render, staticRenderFns } from "./QServTopListComp.vue?vue&type=template&id=0f51c5f5&"
import script from "./QServTopListComp.vue?vue&type=script&lang=js&"
export * from "./QServTopListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports